import {useEffect, useState} from "react";
import {useSchoolFeedInfiniteScroll} from "./useSchoolFeedInfiniteScroll";

export function useSchoolFeedBlockAndWidgetContent(
    baseFilterParams: { [k: string]: any } | null, // valid content item filtering parameters
    orgID?: string,
) {
    const [currentView, setCurrentView] = useState('news');

    const {
        contentItems: newsData,
        error: newsError,
        isLoading: isLoadingNews,
        isValidating: isValidatingNews,
        mutate: mutateNews,
        size: newsSize,
        setSize: setNewsSize,
        totalContentItems: newsTotalContentItems,
    } = useSchoolFeedInfiniteScroll(
        "news",
        "",
        orgID || "",
        {
            is_news: true,
            is_media: true,
            is_file: true,
            is_coursework: true,
            page_size: 15,
            ...baseFilterParams,
        }
    )


    const {
        contentItems: eventsData,
        error: eventsError,
        isLoading: isLoadingEvents,
        isValidating: isValidatingEvents,
        mutate: mutateEvents,
        size: eventsSize,
        setSize: setEventsSize,
        totalContentItems: eventsTotalContentItems,
    } = useSchoolFeedInfiniteScroll(
        "events",
        "",
        orgID || "",
        {
            is_event: true,
            event_end: new Date().toISOString().split("T")[0], // Current date for event end
            ordering: ["json_data__event__start", "created_at"],
            page_size: 15,
            ...baseFilterParams,
        }
    )

    const contentItems = {
        "news": newsData,
        "events": eventsData,
    }
    const total = {
        "news": newsTotalContentItems,
        "events": eventsTotalContentItems,
    }
    const showViewMore = {
        "news": total["news"] > contentItems["news"].length,
        "events": total["events"] > contentItems["events"].length,
    }
    const isLoading = {
        "news": isLoadingNews,
        "events": isLoadingEvents,
    }
    const isValidating = {
        "news": isValidatingNews,
        "events": isValidatingEvents,
    }
    const size = {
        "news": newsSize,
        "events": eventsSize,
    }
    const setSize = {
        "news": setNewsSize,
        "events": setEventsSize,
    }
    const error = {
        "news": newsError,
        "events": eventsError,
    }
    const mutate = {
        "news": mutateNews,
        "events": mutateEvents,
    }

    useEffect(() => {
        if (newsTotalContentItems === 0) {
            setCurrentView("events");
        }
    }, [newsTotalContentItems]);

    return {
        contentItems,
        showViewMore,
        total,
        isLoading,
        isValidating,
        size,
        setSize,
        error,
        mutate,
        currentView,
        setCurrentView,
    };
}
